import React from "react";
import { Modal, ModalBuilder } from "@redriver/cinnamon";
import { Button } from "semantic-ui-react";
import CustomerSignatoryForm from "features/Companies/Customers/Signatories/CustomerSignatoryForm";
import { addClientAuthorisedSignatory } from "features/Companies/Customers/Signatories/actions";

const NewCustomerSignatory = ({
  as: As = Button,
  onSubmitted,
  clientId,
  ...props
}) => {
  return (
    <ModalBuilder
      withForm
      submitAction={addClientAuthorisedSignatory}
      submitParams={{ clientId }}
      onSubmitted={onSubmitted}
      renderTrigger={(showModal) => (
        <As {...props} primary onClick={showModal}>
          Add New Signatory
        </As>
      )}
      renderModal={(modalProps, formProps) => (
        <Modal.Add {...modalProps} header="New Customer Signatory">
          <CustomerSignatoryForm {...formProps} />
        </Modal.Add>
      )}
    />
  );
};
export default NewCustomerSignatory;
